import React, { useState, useEffect } from "react";
import {
    Table,
    Modal,
    Steps,
    Form,
    Input,
    Progress,
    Tag,
    Tooltip,
    Space,
    Spin,
    Button,
    Row,
    Col,
    InputNumber,
    Select,
    message,
    Popconfirm,
    Drawer,
    Card,
} from "antd";
import {
    SearchOutlined,
    EyeOutlined,
    FileProtectOutlined,
    ClearOutlined,
} from "@ant-design/icons";
import Header188 from "../../components/header/header";
import "../Financiero/PlanesCompras/PlanesCompras.css";

import { getParticipantes } from "../../services/financiero/plandecompras/getPlandecompras";
import { getPlanesCompra } from "../../services/financiero/plandecompras/planesdecompra";

import { getProductos } from "../../services/financiero/productos/getProductos";
import FormatoPlanCompras from "../../components/Financiero/PlanesCompras/FormatoPlanCompras"; // 📌 Importa el componente

import { useSelector } from "react-redux";
import InformePlanesCompras from "../../components/Financiero/PlanesCompras/InformePlanesCompras";
import { selectAppPermissions } from '../../store/auth/selectors';
import RealizarEntregaPaati from './RealizarEntregaPaati';

const estados = [
    {
        value: "sin_registrar",
        label: (
            <>
                <Tag color="default">No registrado</Tag>
            </>
        ),
    },
    {
        value: "registrado_sin_firma",
        label: (
            <>
                <Tag color="orange">Registrado sin firma</Tag>
            </>
        ),
    },
    {
        value: "registrado_con_firma",
        label: (
            <>
                <Tag color="green">Registrado con firma</Tag>
            </>
        ),
    },
];
const EntregasPaati = () => {
    const [planes, setPlanes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentPlan, setCurrentPlan] = useState(null);
    const [idcurrentPlan, setIdCurrentPlan] = useState(null);

    const [currentStep, setCurrentStep] = useState(0); // Control del paso actual
    const [stepsVisible, setStepsVisible] = useState(true); // Controla la visibilidad del panel de Steps
    const toggleSteps = () => setStepsVisible(!stepsVisible);
    const [participantes, setParticipantes] = useState([]);
    const [productosPAATY, setProductosPAATY] = useState([]);
    const [productosMap, setProductosMap] = useState({});
    const usernameFromState = useSelector((state) => state.auth.user);

    // Estado para controlar el modal y el mensaje de error
    const [isExceeding, setIsExceeding] = useState(false); // Detecta si el presupuesto fue excedido
    const [proyectado, setProyectado] = useState(0); // Calcula el valor proyectado
    const [isModalVisible, setIsModalVisible] = useState(false); // Controla la visibilidad del modal de advertencia
    const [presupuestoasignado, setPresupuestoasignado] = useState([0]);


    const [showEntregaDrawer, setShowEntregaDrawer] = useState(false);
    const [planSeleccionado, setPlanSeleccionado] = useState(null);

    const [isModalPreviewOpen, setIsModalPreviewOpen] = useState(false);
    const [selectedFiltersAceptacion, setSelectedFiltersAceptacion] = useState(
        []
    );
    const [selectedFiltersDelegacion, setSelectedFiltersDelegacion] = useState(
        []
    );


    const [selectedPlan, setSelectedPlan] = useState(null);


    const [searchText, setSearchText] = useState("");
    const [filteredPlanes, setFilteredPlanes] = useState([]); // Datos filtrados

    const [subtotals, setSubtotals] = useState({
        infraestructura: 0,
        activos: 0,
        herramientas: 0,
        insumos: 0,
        gastos: 0,
        contrapartida: 0,
    });

    const [selectedProductDetails, setSelectedProductDetails] = useState(null);
    const [isModalVisibleP, setIsModalVisibleP] = useState(false);

    const [selectedDepartamento, setSelectedDepartamento] = useState(null);
    const [selectedMunicipio, setSelectedMunicipio] = useState(null);

    const [showInforme, setShowInforme] = useState(false);


    //Control de Permisos
    const appName = 'entregaspaati';
    const permissions = useSelector((state) => selectAppPermissions(state, appName));
    const permissionDelete = permissions.priv_delete === 'Y';
    const permissionUpdate = permissions.priv_update === 'Y';
    const permissionInsert = permissions.priv_insert === 'Y';
    const permissionExport = permissions.priv_export === 'Y';
    const userBodecom = useSelector((state) => state.auth.user);


    // Función para cerrar el modal
    const handleCloseModalP = () => {
        setIsModalVisibleP(false);
    };

    // 📌 Función para abrir el modal con los detalles del plan seleccionado
    const handlePreview = (plan) => {
        setSelectedPlan(plan);
        setIsModalPreviewOpen(true);
    };

    // 📌 Función para cerrar el modal
    const handleClosePreview = () => {
        setIsModalPreviewOpen(false);
        setSelectedPlan(null);
    };

    // Calcula el valor proyectado cada vez que los subtotales cambien
    useEffect(() => {
        const totalProyectado = Object.values(subtotals).reduce(
            (acc, val) => acc + val,
            0
        );
        if (totalProyectado > presupuestoasignado) {
            setIsExceeding(true);
            handleOpenModal();
        } else {
            setIsExceeding(false);
        }
    }, [subtotals, presupuestoasignado]);

    // Función para abrir el modal cuando se detecta un exceso
    const handleOpenModal = () => {
        setIsModalVisible(true);
    };

    const [form] = Form.useForm();

    // Función para cargar los datos desde el servicio
    const fetchPlanes = async () => {
        try {
            const response = await getPlanesCompra(); // Llama al servicio
            if (response.status === 200) {

                const processedData = response.data.map((item) => ({
                    ...item,
                    dataItems:
                        typeof item.dataItems === "string"
                            ? JSON.parse(item.dataItems)
                            : item.dataItems,
                    conceptoInversion:
                        typeof item.conceptoInversion === "string"
                            ? JSON.parse(item.conceptoInversion)
                            : item.conceptoInversion,
                }));

                const planesAceptados = processedData.filter(plan => plan.estado_aceptacion === 1);


                setPlanes(planesAceptados);
                setFilteredPlanes(planesAceptados);

            } else {
                console.error(
                    "Error al obtener los planes de compra:",
                    response.message
                );
            }
        } catch (error) {
            console.error("❌ Error al cargar los planes de compra:", error);
        }
    };


    // Cargar los ProductosPAATY desde el servicio

    const fetchProductosPAATY = async () => {
        setLoading(true);
        try {
            const response = await getProductos();
            if (response) {
                const options = response.map((item) => ({
                    value: item.oid,
                    label: `${item.codigo} - ${item.nombre_producto}`,
                    oidUnidadeMedida: item.oid_unidad_medida,
                }));

                const map = response.reduce((acc, item) => {
                    acc[item.oid] = item; // Guardar todos los datos del producto
                    return acc;
                }, {});

                setProductosPAATY(options);
                setProductosMap(map);
            } else {
                console.error("Error al cargar los productos:", response.message);
            }
        } catch (error) {
            console.error("Error al cargar los productos:", error);
        } finally {
            setLoading(false);
        }
    };

    // Llama a fetchProductosPAATY al montar el componente
    useEffect(() => {
        fetchProductosPAATY();
    }, []);


    useEffect(() => {
        fetchPlanes();
    }, []);

    useEffect(() => {
        if (currentPlan && participantes.length > 0) {
            const codSirArray = Array.isArray(currentPlan.codSir)
                ? currentPlan.codSir
                : currentPlan.codSir
                    ? currentPlan.codSir.split(",").map((item) => item.trim())
                    : [];

            const codSirFormatted = codSirArray.map((codigo) => {
                const participante = participantes.find(
                    (p) => p.value.trim() === codigo.trim()
                );
                return participante
                    ? codigo // 🔥 Solo el valor puro
                    : codigo;
            });

            form.setFieldsValue({
                codSir: codSirFormatted,
            });
        }
    }, [participantes, currentPlan, form]);



    // 📌 Calcula la sumatoria de cada concepto
    const totalizarConceptos = (data) => {
        const totals = {
            infraestructura: 0,
            activos: 0,
            herramientas: 0,
            insumos: 0,
            gastos: 0,
            contrapartida: 0,
            total: 0,
        };

        data.forEach((plan) => {
            plan.conceptoInversion.forEach((concepto) => {
                switch (concepto.concepto) {
                    case "A. Infraestructura":
                        totals.infraestructura += concepto.valor;
                        break;
                    case "B. Activos Productivos y equipos":
                        totals.activos += concepto.valor;
                        break;
                    case "C. Herramientas y Mobiliario":
                        totals.herramientas += concepto.valor;
                        break;
                    case "D. Insumos":
                        totals.insumos += concepto.valor;
                        break;
                    case "E. Gastos Operativos":
                        totals.gastos += concepto.valor;
                        break;
                    case "F. Contrapartida":
                        totals.contrapartida += concepto.valor;
                        break;
                    case "TOTAL PROYECTO":
                        totals.total += concepto.valor;
                        break;
                    default:
                        break;
                }
            });
        });

        return totals;
    };

    // 📌 Obtiene los totales calculados
    const totals = totalizarConceptos(planes);

    const handleEntrega = (record) => {

        setPlanSeleccionado(record);
        setShowEntregaDrawer(true);
    };

    const columns = [
        {
            title: "Acciones",
            key: "acciones",
            align: "center",
            render: (_, record) => (
                <Space>
                    <Tooltip title="Ver">
                        <Button
                            type="primary"
                            icon={<EyeOutlined />}
                            onClick={() => handlePreview(record)}
                        />
                    </Tooltip>

                    <Tooltip title="Exportar a Excel">
                        <FormatoPlanCompras plan={record} />
                    </Tooltip>

                    <Tooltip title="Realizar entrega">
                        <Button
                            type="primary"
                            icon={<FileProtectOutlined />}
                            onClick={() => handleEntrega(record)}
                            style={{ backgroundColor: "#4caf50", borderColor: "#4caf50" }}
                        />
                    </Tooltip>


                </Space>
            ),
        },

        {
            title: "Formato aceptación",
            key: "formato_aceptacion",
            align: "center",
            render: (_, record) => {
                if (record.tiene_aceptacion === 0) {
                    return <Tag color="default">No registrado</Tag>;
                }

                if (record.estado_aceptacion === 0) {
                    return <Tag color="orange">Registrado sin firma</Tag>;
                }

                if (record.estado_aceptacion === 1) {
                    return <Tag color="green">Registrado con firma</Tag>;
                }

                return null;
            },
        },
        {
            title: "Formato delegación",
            key: "formato_delegacion",
            align: "center",
            render: (_, record) => {
                if (record.tiene_delegacion === 0) {
                    return <Tag color="default">No registrado</Tag>;
                }

                if (record.estado_delegacion === 0) {
                    return <Tag color="orange">Registrado sin firma</Tag>;
                }

                if (record.estado_delegacion === 1) {
                    return <Tag color="green">Registrado con firma</Tag>;
                }

                return null; // En caso de datos inconsistentes
            },
        },

        {
            title: "Código SIR",
            dataIndex: "codSir",
            key: "codSir",
            align: "center",
            width: 300, // 🔹 Define un ancho fijo
            render: (text) => {
                // Si el texto tiene más de 10 caracteres, lo recorta y añade '...'
                const isLong = text.length > 50;
                const displayText = isLong ? `${text.substring(0, 50)}...` : text;

                return (
                    <Tooltip title={text}>
                        <span>{displayText}</span>
                    </Tooltip>
                );
            },
        },

        {
            title: "Nombres",
            dataIndex: "nombres_if",
            width: 300,
            render: (text) => {
                // Si el texto tiene más de 10 caracteres, lo recorta y añade '...'
                const isLong = text.length > 50;
                const displayText = isLong ? `${text.substring(0, 50)}...` : text;

                return (
                    <Tooltip title={text}>
                        <span>{displayText}</span>
                    </Tooltip>
                );
            },
            key: "nombres_if",
        },

        {
            title: "Departamento",
            dataIndex: "departamento",
            key: "departamento",
        },
        {
            title: "Municipio",
            dataIndex: "municipio",
            key: "municipio",
        },

        {
            title: "Total Proyecto",
            dataIndex: "conceptoInversion",
            key: "total",
            align: "right",
            render: (conceptoInversion) => {
                const concepto = conceptoInversion?.find(
                    (c) => c.concepto === "TOTAL PROYECTO"
                );
                return concepto
                    ? concepto.valor.toLocaleString("es-CO", {
                        style: "currency",
                        currency: "COP",
                    })
                    : "-";
            },
        },
        {
            title: "Usuario",
            dataIndex: "user",
            key: "user",
        },
        {
            title: "A. Infraestructura",
            dataIndex: "conceptoInversion",
            key: "infraestructura",
            align: "right",
            render: (conceptoInversion) => {
                const concepto = conceptoInversion?.find(
                    (c) => c.concepto === "A. Infraestructura"
                );
                return concepto
                    ? concepto.valor.toLocaleString("es-CO", {
                        style: "currency",
                        currency: "COP",
                    })
                    : "-";
            },
        },
        {
            title: "B. Activos Productivos y equipos",
            dataIndex: "conceptoInversion",
            key: "activos",
            align: "right",
            render: (conceptoInversion) => {
                const concepto = conceptoInversion?.find(
                    (c) => c.concepto === "B. Activos Productivos y equipos"
                );
                return concepto
                    ? concepto.valor.toLocaleString("es-CO", {
                        style: "currency",
                        currency: "COP",
                    })
                    : "-";
            },
        },
        {
            title: "C. Herramientas y Mobiliario",
            dataIndex: "conceptoInversion",
            key: "herramientas",
            align: "right",
            render: (conceptoInversion) => {
                const concepto = conceptoInversion?.find(
                    (c) => c.concepto === "C. Herramientas y Mobiliario"
                );
                return concepto
                    ? concepto.valor.toLocaleString("es-CO", {
                        style: "currency",
                        currency: "COP",
                    })
                    : "-";
            },
        },
        {
            title: "D. Insumos",
            dataIndex: "conceptoInversion",
            key: "insumos",
            align: "right",
            render: (conceptoInversion) => {
                const concepto = conceptoInversion?.find(
                    (c) => c.concepto === "D. Insumos"
                );
                return concepto
                    ? concepto.valor.toLocaleString("es-CO", {
                        style: "currency",
                        currency: "COP",
                    })
                    : "-";
            },
        },
        {
            title: "E. Gastos Operativos",
            dataIndex: "conceptoInversion",
            key: "gastos",
            align: "right",
            render: (conceptoInversion) => {
                const concepto = conceptoInversion?.find(
                    (c) => c.concepto === "E. Gastos Operativos"
                );
                return concepto
                    ? concepto.valor.toLocaleString("es-CO", {
                        style: "currency",
                        currency: "COP",
                    })
                    : "-";
            },
        },
        {
            title: "F. Contrapartida",
            dataIndex: "conceptoInversion",
            key: "contrapartida",
            align: "right",
            render: (conceptoInversion) => {
                const concepto = conceptoInversion?.find(
                    (c) => c.concepto === "F. Contrapartida"
                );
                return concepto
                    ? concepto.valor.toLocaleString("es-CO", {
                        style: "currency",
                        currency: "COP",
                    })
                    : "-";
            },
        },

        {
            title: "Fecha Creación",
            dataIndex: "fecha_creacion",
            key: "fecha_creacion",
            align: "center",
            render: (fecha) =>
                new Date(fecha).toLocaleDateString("es-CO", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                }),
        },
        {
            title: "Última Actualización",
            dataIndex: "fecha_actualizacion",
            key: "fecha_actualizacion",
            align: "center",
            render: (fecha) =>
                new Date(fecha).toLocaleDateString("es-CO", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                }),
        },
    ];

    const renderProgressBar = (value) => {
        const porcentaje =
            totalProyecto > 0 ? ((value / totalProyecto) * 100).toFixed(2) : 0;
        return (
            <Progress
                percent={porcentaje}
                strokeColor="#1890ff"
                showInfo
                format={(percent) => `${percent}%`}
                status="active"
                style={{ width: "150px", marginLeft: "10px" }}
            />
        );
    };

    useEffect(() => {
        const totalProyectado = Object.values(subtotals).reduce(
            (acc, val) => acc + val,
            0
        );
        setProyectado(totalProyectado);
    }, [subtotals]);

    const filtrarPlanes = () => {
        let resultado = [...planes];

        // 1. Filtrar por texto código SIR
        if (searchText.trim() !== "") {
            resultado = resultado.filter((plan) =>
                plan.codSir.toLowerCase().includes(searchText.toLowerCase())
            );
        }

        // 2. Filtrar por estado de Aceptación
        if (selectedFiltersAceptacion.length > 0) {
            resultado = resultado.filter((plan) => {
                // Determinar el estado string según tu lógica de render
                let estadoAceptacion;
                if (plan.tiene_aceptacion === 0) {
                    estadoAceptacion = "sin_registrar";
                } else if (plan.estado_aceptacion === 0) {
                    estadoAceptacion = "registrado_sin_firma";
                } else if (plan.estado_aceptacion === 1) {
                    estadoAceptacion = "registrado_con_firma";
                } else {
                    // Por si acaso hay otro caso (null / undefined)
                    return false;
                }
                return selectedFiltersAceptacion.includes(estadoAceptacion);
            });
        }

        // 3. Filtrar por estado de Delegación (misma estructura de lógica)
        if (selectedFiltersDelegacion.length > 0) {
            resultado = resultado.filter((plan) => {
                let estadoDelegacion;
                if (plan.tiene_delegacion === 0) {
                    estadoDelegacion = "sin_registrar";
                } else if (plan.estado_delegacion === 0) {
                    estadoDelegacion = "registrado_sin_firma";
                } else if (plan.estado_delegacion === 1) {
                    estadoDelegacion = "registrado_con_firma";
                } else {
                    return false;
                }
                return selectedFiltersDelegacion.includes(estadoDelegacion);
            });
        }

        // 4. Filtrar por departamento
        if (selectedDepartamento) {
            resultado = resultado.filter(
                (plan) => plan.departamento === selectedDepartamento
            );
        }

        // 5. Filtrar por municipio
        if (selectedMunicipio) {
            resultado = resultado.filter(
                (plan) => plan.municipio === selectedMunicipio
            );
        }

        setFilteredPlanes(resultado);
    };

    useEffect(() => {
        filtrarPlanes();
    }, [
        searchText,
        selectedFiltersAceptacion,
        selectedFiltersDelegacion,
        selectedDepartamento,
        selectedMunicipio,

    ]);

    const totalProyecto = Object.values(totals).reduce(
        (acc, val) => acc + val,
        0
    );

    // Devuelve departamentos únicos
    const getDepartamentosUnicos = () => {
        const departamentos = planes
            .map((plan) => plan.departamento)
            .filter(Boolean);
        return [...new Set(departamentos)];
    };

    // Devuelve municipios únicos del departamento seleccionado
    const getMunicipiosUnicos = (departamento) => {
        if (!departamento) return [];
        const municipios = planes
            .filter((plan) => plan.departamento === departamento)
            .map((plan) => plan.municipio)
            .filter(Boolean);
        return [...new Set(municipios)];
    };

    return (
        <>
            <div className="container mt-4">
                <Header188 type="entregaspaati" />

                <Row gutter={[16, 16]} align="middle" style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
                    {/* Código SIR */}
                    <Col xs={24} sm={12} md={8} lg={6} xl={3}>
                        <Input
                            placeholder="Código SIR"
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            prefix={<SearchOutlined />}
                            allowClear
                            style={{ width: '100%' }}
                        />
                    </Col>

                    {/* Estado Delegación */}
                    <Col xs={24} sm={12} md={8} lg={6} xl={3}>
                        <Select
                            mode="multiple"
                            placeholder="Estado Delegación"
                            style={{ width: '100%' }}
                            value={selectedFiltersDelegacion}
                            options={estados}
                            allowClear
                            onChange={setSelectedFiltersDelegacion}
                        />
                    </Col>

                    {/* Departamento */}
                    <Col xs={24} sm={12} md={8} lg={6} xl={3}>
                        <Select
                            placeholder="Departamento"
                            style={{ width: '100%' }}
                            value={selectedDepartamento}
                            allowClear
                            onChange={(value) => {
                                setSelectedDepartamento(value);
                                setSelectedMunicipio(null);
                            }}
                            options={getDepartamentosUnicos().map(dep => ({ value: dep, label: dep }))}
                        />
                    </Col>

                    {/* Municipio */}
                    <Col xs={24} sm={12} md={8} lg={6} xl={3}>
                        <Select
                            placeholder="Municipio"
                            style={{ width: '100%' }}
                            value={selectedMunicipio}
                            allowClear
                            disabled={!selectedDepartamento}
                            onChange={setSelectedMunicipio}
                            options={getMunicipiosUnicos(selectedDepartamento).map(mun => ({ value: mun, label: mun }))}
                        />
                    </Col>

                    {/* Limpiar */}
                    <Col xs={12} sm={6} md={4} lg={3} xl={2}>
                        <Tooltip title="Limpiar filtros">
                            <Button
                                icon={<ClearOutlined />}
                                onClick={() => {
                                    setSearchText("");
                                    setSelectedFiltersAceptacion([]);
                                    setSelectedFiltersDelegacion([]);
                                    setSelectedDepartamento(null);
                                    setSelectedMunicipio(null);
                                    setFilteredPlanes(planes);
                                }}
                                style={{ width: '100%' }}
                            />
                        </Tooltip>
                    </Col>

                    {/* Total Registros */}
                    <Col xs={24} sm={12} md={8} lg={6} xl={3}>
                        <Card
                            size="small"
                            style={{
                                backgroundColor: "#f0f5ff",
                                width: "100%",
                                padding: "8px 16px",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                            }}
                        >
                            <span><strong>Registros: </strong></span>
                            <span style={{ color: "#1890ff", fontWeight: "bold" }}>{filteredPlanes.length}</span>
                        </Card>

                    </Col>

                    {/* Ver Informe */}
                    <Col xs={24} sm={12} md={8} lg={6} xl={3}>
                        <Tooltip title="Ver informe de los planes filtrados">
                            <Button
                                type="default"
                                onClick={() => setShowInforme(true)}
                                style={{
                                    width: '100%',
                                    backgroundColor: '#0B80C4',
                                    color: 'white',
                                    fontWeight: 'bold',
                                }}
                            >
                                Ver informe
                            </Button>
                        </Tooltip>
                    </Col>


                </Row>


                <Table
                    columns={columns}
                    dataSource={filteredPlanes} // Ahora siempre tendrá datos correctos
                    loading={loading}
                    rowKey="oid"
                    bordered
                    pagination={{ pageSize: 10 }} // 📌 Agrega paginación
                    scroll={{ x: "max-content" }} // 📌 Habilita desplazamiento horizontal
                    footer={() => (
                        <div
                            style={{
                                fontWeight: "bold",
                                textAlign: "center",
                                padding: "10px 0",
                                backgroundColor: "#f5f5f5",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "15px",
                                }}
                            >
                                <span>
                                    Total Infraestructura:{" "}
                                    {totals.infraestructura.toLocaleString("es-CO", {
                                        style: "currency",
                                        currency: "COP",
                                    })}
                                </span>
                                {renderProgressBar(totals.infraestructura)}

                                <span>
                                    Total Activos:{" "}
                                    {totals.activos.toLocaleString("es-CO", {
                                        style: "currency",
                                        currency: "COP",
                                    })}
                                </span>
                                {renderProgressBar(totals.activos)}

                                <span>
                                    Total Herramientas:{" "}
                                    {totals.herramientas.toLocaleString("es-CO", {
                                        style: "currency",
                                        currency: "COP",
                                    })}
                                </span>
                                {renderProgressBar(totals.herramientas)}

                                <span>
                                    Total Insumos:{" "}
                                    {totals.insumos.toLocaleString("es-CO", {
                                        style: "currency",
                                        currency: "COP",
                                    })}
                                </span>
                                {renderProgressBar(totals.insumos)}

                                <span>
                                    Total Gastos:{" "}
                                    {totals.gastos.toLocaleString("es-CO", {
                                        style: "currency",
                                        currency: "COP",
                                    })}
                                </span>
                                {renderProgressBar(totals.gastos)}

                                <span>
                                    Total Contrapartidas:{" "}
                                    {totals.contrapartida.toLocaleString("es-CO", {
                                        style: "currency",
                                        currency: "COP",
                                    })}
                                </span>
                                {renderProgressBar(totals.contrapartida)}

                                <span style={{ color: "blue" }}>
                                    TOTAL PROYECTOS:{" "}
                                    {totals.total.toLocaleString("es-CO", {
                                        style: "currency",
                                        currency: "COP",
                                    })}
                                </span>
                            </div>
                        </div>
                    )}
                />

                {/* Modal para mostrar detalles del producto */}
                <Modal
                    title={
                        <span style={{ fontWeight: "bold", fontSize: "18px" }}>
                            🛒 Detalles del Producto
                        </span>
                    }
                    open={isModalVisibleP}
                    onCancel={handleCloseModalP}
                    footer={[
                        <Button key="close" type="primary" onClick={handleCloseModalP}>
                            Cerrar
                        </Button>,
                    ]}
                >
                    {selectedProductDetails && (
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "10px",
                                fontSize: "16px",
                            }}
                        >
                            {/* Producto */}
                            <div>
                                <Tag color="blue">Producto: </Tag>
                                <span style={{ fontWeight: "bold" }}>
                                    {" "}
                                    {selectedProductDetails.nombre_producto}
                                </span>
                            </div>

                            {/* Descripción */}
                            <div>
                                <Tag color="green">Descripción:</Tag>
                                <span> {selectedProductDetails.descripcion_producto}</span>
                            </div>

                            {/* Precio COP */}
                            <div>
                                <Tag color="gold">Precio de referencia COP: </Tag>
                                <span style={{ fontWeight: "bold", color: "#198754" }}>
                                    {new Intl.NumberFormat("es-CO", {
                                        style: "currency",
                                        currency: "COP",
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    }).format(selectedProductDetails.precio_unitarioPesos)}
                                </span>
                            </div>

                            {/* Precio USD */}
                            <div>
                                <Tag color="purple">Precio de referencia USD: </Tag>
                                <span style={{ fontWeight: "bold", color: "#6f42c1" }}>
                                    {new Intl.NumberFormat("es-CO", {
                                        style: "currency",
                                        currency: "USD",
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    }).format(selectedProductDetails.precio_usd)}
                                </span>
                            </div>

                            {/* Unidad de medida */}
                            <div>
                                <Tag color="red">Unidad: </Tag>
                                <span> {selectedProductDetails.nombreUnidadMedida}</span>
                            </div>

                            {/* Tipo */}
                            <div>
                                <Tag color="cyan">Categoría:</Tag>
                                <span> {selectedProductDetails.nombreCategoria}</span>
                            </div>

                            {/* Fungible */}
                            <div>
                                <Tag color="magenta">Fungible /No Fungible:</Tag>
                                <span> {selectedProductDetails.fungible}</span>
                            </div>
                        </div>
                    )}
                </Modal>

                {/* Modal para mostrar detalles del plan de compras */}
                <Modal
                    title={
                        <span style={{ fontWeight: "bold", fontSize: "18px" }}>
                            📄 Detalles del Plan de Compras
                        </span>
                    }
                    open={isModalPreviewOpen}
                    onCancel={handleClosePreview}
                    footer={[
                        <Button key="close" type="primary" onClick={handleClosePreview}>
                            Cerrar
                        </Button>,
                    ]}
                    style={{ top: 20 }}
                >
                    {selectedPlan && (
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "12px",
                                fontSize: "16px",
                            }}
                        >
                            {/* Usuario */}
                            <div>
                                <Tag color="blue">Usuario: </Tag>
                                <span style={{ fontWeight: "bold" }}>{selectedPlan.user}</span>
                            </div>

                            {/* Código SIR */}
                            <div>
                                <Tag color="green">Código SIR:</Tag>
                                <span>{selectedPlan.codSir}</span>
                            </div>

                            {/* Fecha de Creación */}
                            <div>
                                <Tag color="gold">Fecha de Creación:</Tag>
                                <span>
                                    {new Date(selectedPlan.fecha_creacion).toLocaleString(
                                        "es-CO"
                                    )}
                                </span>
                            </div>

                            {/* Última Actualización */}
                            <div>
                                <Tag color="purple">Última Actualización:</Tag>
                                <span>
                                    {new Date(selectedPlan.fecha_actualizacion).toLocaleString(
                                        "es-CO"
                                    )}
                                </span>
                            </div>

                            {/* Conceptos de Inversión */}
                            <div>
                                <h4>Conceptos de Inversión</h4>
                                <Table
                                    dataSource={selectedPlan.conceptoInversion}
                                    pagination={false}
                                    rowKey="concepto"
                                    columns={[
                                        {
                                            title: "Concepto",
                                            dataIndex: "concepto",
                                            key: "concepto",
                                        },
                                        {
                                            title: "Valor",
                                            dataIndex: "valor",
                                            key: "valor",
                                            align: "right",
                                            render: (value) =>
                                                value.toLocaleString("es-CO", {
                                                    style: "currency",
                                                    currency: "COP",
                                                }),
                                        },
                                        {
                                            title: "% del Total",
                                            dataIndex: "porcentaje",
                                            key: "porcentaje",
                                            align: "center",
                                        },
                                    ]}
                                    bordered
                                    size="small"
                                />
                            </div>
                        </div>
                    )}
                </Modal>


                {/* Drawer para el informe */}
                <Drawer
                    title={
                        <span style={{ fontWeight: "bold", fontSize: 18 }}>
                            Informe de Planes de Compra
                        </span>
                    }
                    placement="right"
                    open={showInforme}
                    onClose={() => setShowInforme(false)}
                    width="100vw"
                    styles={{ padding: 0 }}
                    closeIcon={
                        <span
                            style={{ color: "#fff", fontSize: 20 }}
                            className="anticon anticon-close"
                        >
                            <svg
                                viewBox="64 64 896 896"
                                focusable="false"
                                data-icon="close"
                                width="1em"
                                height="1em"
                                fill="currentColor"
                                aria-hidden="true"
                            >
                                <path d="M563.8 512l262.1-262.1a7.92 7.92 0 0 0 0-11.3l-51.4-51.4a7.92 7.92 0 0 0-11.3 0L501.1 449.3 239 187.2a7.92 7.92 0 0 0-11.3 0l-51.4 51.4a7.92 7.92 0 0 0 0 11.3l262.1 262.1-262.1 262.1a7.92 7.92 0 0 0 0 11.3l51.4 51.4a7.92 7.92 0 0 0 11.3 0l262.1-262.1 262.1 262.1a7.92 7.92 0 0 0 11.3 0l51.4-51.4a7.92 7.92 0 0 0 0-11.3L563.8 512z"></path>
                            </svg>
                        </span>
                    }
                >
                    <div style={{ height: "100vh", overflowY: "auto", padding: 24 }}>
                        <InformePlanesCompras planes={planes} />
                    </div>
                </Drawer>

                {/* Drawer para las entregas */}
                <RealizarEntregaPaati
                    open={showEntregaDrawer}
                    onClose={() => setShowEntregaDrawer(false)}
                    record={planSeleccionado}
                />


            </div>
        </>
    );
};

export default EntregasPaati;
